import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './agcensus-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class AgcensusDetailComponent extends AbstractCollectionDirective {}
